import React from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import Frame11 from "../../../Images/Frame 11.jpg";
import Frame12 from "../../../Images/Frame 12.jpg";
import Frame13 from "../../../Images/Frame 13.jpg";
import Frame14 from "../../../Images/Frame 14.jpg";
import Frame15 from "../../../Images/Frame 15.jpg";
import Frame16 from "../../../Images/Frame 16.jpg";
import Frame17 from "../../../Images/Frame 17.jpg";
import Frame18 from "../../../Images/Frame 18.jpg";
import Frame19 from "../../../Images/Frame 19.jpg";
import "./ImmersiveBeauty.css";

const categories = ["All", "Makeup", "Hairstyle", "Eyebrow"];

const ImmersiveBeauty = () => {
  useEffect(() => {
    AOS.init({
      duration: 800, // animation duration in ms
      once: false, // play animation every time on scroll
      mirror: true, // animate out when scrolling past
    });
  }, []);
  return (
    <div className="beauty-gallery">
      <div className="gallery-title">
        Explore immersive beauty with{" "}
        <span className="brand-highlight">NIAVH</span>
      </div>

      <div className="category-bar">
        {categories.map((cat, index) => (
          <button
            key={index}
            className={`category-btn ${index === 0 ? "active" : ""}`}
          >
            {cat}
          </button>
        ))}
      </div>

      <div className="masonry-layout">
        {/* Column 1: 2 images stacked vertically */}
        <div className="vertical-column">
          <div className="grid-item1" data-aos="fade-up" data-aos-delay="100">
            <img src={Frame11} alt="img-1" />
          </div>
          <div className="grid-item3" data-aos="fade-up" data-aos-delay="200">
            <img src={Frame12} alt="img-2" />
          </div>
        </div>

        {/* Column 2: 2 images stacked vertically */}
        <div className="vertical-column">
          <div className="grid-item3" data-aos="fade-up" data-aos-delay="300">
            <img src={Frame13} alt="img-3" />
          </div>
          <div className="grid-item4" data-aos="fade-up" data-aos-delay="400">
            <img src={Frame19} alt="img-4" />
          </div>
        </div>

        {/* Column 3: 3 images stacked vertically */}
        <div className="vertical-column">
          <div className="grid-item5" data-aos="fade-up" data-aos-delay="500">
            <img src={Frame14} alt="img-5" />
          </div>
          <div className="grid-item6" data-aos="fade-up" data-aos-delay="600">
            <img src={Frame18} alt="img-6" />
          </div>
          <div className="grid-item7" data-aos="fade-up" data-aos-delay="700">
            <img src={Frame16} alt="img-7" />
          </div>
        </div>

        {/* Column 4: 2 images stacked vertically */}
        <div className="vertical-column">
          <div className="grid-item8" data-aos="fade-up" data-aos-delay="800">
            <img src={Frame15} alt="img-8" />
          </div>
          <div className="grid-item9" data-aos="fade-up" data-aos-delay="900">
            <img src={Frame17} alt="img-9" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImmersiveBeauty;
